import React, { useEffect } from 'react';

export default function RefundPolicy() {
  useEffect(() => {
    document.title = "Politique de Remboursement | Tv Plux";
    // Re-initialize jQuery/Swiper plugins after React renders
    if (window.$ && window.$.fn.waypoint) {
      window.$(window).trigger('resize');
    }
    // Re-init Swiper if available
    if (window.Swiper) {
      const swiperEl = document.querySelector('.card__content');
      const swiperFeed = document.querySelector('.card__content_feed');
      if (swiperEl && !swiperEl.swiper) {
        new window.Swiper('.card__content', {
          loop: true, autoplay: { delay: 600 }, centeredSlides: true,
          pagination: { el: '.swiper-pagination', clickable: true, dynamicBullets: true },
          breakpoints: { 320: { slidesPerView: 2, spaceBetween: 10 }, 480: { slidesPerView: 2, spaceBetween: 10 }, 640: { slidesPerView: 5, spaceBetween: 15 } }
        });
      }
      if (swiperFeed && !swiperFeed.swiper) {
        new window.Swiper('.card__content_feed', {
          loop: true, autoplay: { delay: 2500 }, centeredSlides: true,
          pagination: { el: '.swiper-pagination', clickable: true, dynamicBullets: true },
          breakpoints: { 320: { slidesPerView: 1, spaceBetween: 10 }, 480: { slidesPerView: 1, spaceBetween: 10 }, 640: { slidesPerView: 1, spaceBetween: 15 } }
        });
      }
    }
  }, []);

  return (
    <div dangerouslySetInnerHTML={{ __html: `<!--body overlay -->
    <div class="body-overlay"></div>
    
    <!--main content wrapper start-->
    <div class="main-wrapper">
        
        <!--header area start-->

        

    
        <!--header area end-->
        

      <!--breadcrumb area start-->
      <section class="breadcrumb-area bg-primary-gradient">
        <div class="container">
            <div class="breadcrumb-content text-center">
                <h2 class="mb-3">Politique de Remboursement</h2>
                <nav>
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="/">Home</a></li>
                        <li class="breadcrumb-item"><a href="#">Pages</a></li>
                        <li class="breadcrumb-item active ">Politique de Confidentialité</li>
                    </ol>
                </nav>
            </div>
        </div>
    </section>
    <!--breadcrumb area end-->

    <!--blog grid start-->
    <section class="hm-blog-grids pt-80 pb-80 overflow-hidden">
        <div class="container">
            <div class="row g-5">
                <div class="col-xl-12">
                    <div class="terms-and-conditions">
                        <div class="mb-5">
                            <h3>1. Droit au remboursement</h3>
                            <p>Chez TVPLUX, nous nous engageons à garantir votre satisfaction. C'est pourquoi nous offrons une politique de remboursement de 15 jours pour tous nos utilisateurs. Si, pour une raison quelconque, vous n'êtes pas satisfait de nos services, vous pouvez demander un remboursement dans un délai de 15 jours après votre achat.</p>
                        
                            <h3>2. Conditions de remboursement</h3>
                            <p>Pour être éligible à un remboursement, les conditions suivantes doivent être remplies :</p>
                            <ul>
                                <li>La demande doit être effectuée dans les 15 jours suivant la date d'achat.</li>
                                <li>Vous devez fournir une preuve d'achat valide, telle que votre reçu ou votre email de confirmation.</li>
                                <li>Les remboursements ne sont pas disponibles si vous avez déjà utilisé plus de 50% de votre période d'abonnement.</li>
                            </ul>
                        
                            <h3>3. Processus de demande</h3>
                            <p>Pour demander un remboursement, veuillez suivre ces étapes :</p>
                            <ol>
                                <li>Contactez notre service client via WhatsApp ou email en expliquant la raison de votre demande.</li>
                                <li>Fournissez votre preuve d'achat (numéro de commande, email, etc.).</li>
                                <li>Notre équipe traitera votre demande de remboursement immédiatement après sa réception.</li>
                            </ol>
                        
                            <h3>4. Mode de remboursement</h3>
                            <p>Si votre demande de remboursement est approuvée, le montant sera retourné via le même mode de paiement que celui utilisé lors de votre achat. Le délai de traitement peut varier en fonction de votre fournisseur de paiement.</p>
                        
                            <h3>5. Contactez-nous</h3>
                            <p>Pour toute question ou assistance concernant notre Politique de Remboursement, n'hésitez pas à nous contacter :</p>
                            <ul>
                                <li><strong>Email :</strong> contact@tvplux.com</li>
                                <li><strong>WhatsApp :</strong> <a href="https://wa.me/33756756461" target="_blank">Cliquez ici pour nous contacter</a></li>
                            </ul>
                        
                            <p>Chez TVPLUX, nous nous efforçons de vous offrir un service de qualité. Votre satisfaction est notre priorité, et nous sommes toujours là pour vous aider.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

<!--FAQ Start-->

<section class="faq-modern-section">
    <div class="container">
        <div class="faq-modern-header text-center mb-5">
            <span class="faq-modern-label">FAQ</span>
            <h2 class="faq-modern-title">Questions Fréquemment Posées</h2>
            <p class="faq-modern-subtitle">Découvrez les réponses aux questions les plus courantes sur notre service IPTV.</p>
        </div>
        <div class="row g-4" id="faqAccordion">

            <div class="col-lg-6 col-md-12">
                <div class="faq-modern-card faq-open">
                    <a href="#faqCollapseOne" class="faq-modern-trigger text-decoration-none" data-bs-toggle="collapse" aria-expanded="true" aria-controls="faqCollapseOne">
                        <div class="faq-modern-trigger-inner">
                            <div class="faq-modern-icon-wrap"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="15" height="15" fill="#ffffff"><path d="M240.5 224H352C365.3 224 376.3 232.9 379.5 245.8s-2.3 26.1-13.5 34l-160 112c-10.6 7.4-24.7 7.9-35.7 1.1S154.5 375.4 157 362.7L176 272H64C50.7 272 39.7 263.1 36.5 250.2s2.3-26.1 13.5-34l160-112c10.6-7.4 24.7-7.9 35.7-1.1s16.3 18.1 13.8 30.9L240.5 224z"/></svg></div>
                            <h5 class="faq-modern-question">Le prix est-il mensuel ? Vais-je être facturé à nouveau ?</h5>
                            <div class="faq-modern-toggle"><span class="faq-toggle-minus">−</span><span class="faq-toggle-plus">+</span></div>
                        </div>
                    </a>
                    <div id="faqCollapseOne" class="collapse show" data-bs-parent="#faqAccordion">
                        <div class="faq-modern-body">Non, c'est un paiement unique. Nous ne facturons pas de frais mensuels et nous ne renouvelons pas automatiquement votre abonnement. Vous payez une seule fois et obtenez l'accès pour la période choisie (par exemple, un an, 15 mois ou 24 mois...).</div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="faq-modern-card">
                    <a href="#faqCollapseTwo" class="faq-modern-trigger text-decoration-none" data-bs-toggle="collapse" aria-expanded="false" aria-controls="faqCollapseTwo">
                        <div class="faq-modern-trigger-inner">
                            <div class="faq-modern-icon-wrap"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="15" height="15" fill="#ffffff"><path d="M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"/></svg></div>
                            <h5 class="faq-modern-question">Comment s'abonner à IPTV ?</h5>
                            <div class="faq-modern-toggle"><span class="faq-toggle-minus">−</span><span class="faq-toggle-plus">+</span></div>
                        </div>
                    </a>
                    <div id="faqCollapseTwo" class="collapse" data-bs-parent="#faqAccordion">
                        <div class="faq-modern-body">Pour vous abonner à IPTV, visitez notre site web et choisissez un abonnement adapté à vos besoins. Vous serez redirigé vers un autre site pour finaliser votre paiement. Une fois cela terminé, vous recevrez vos codes avec des instructions détaillées.</div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="faq-modern-card">
                    <a href="#faqCollapseSeven" class="faq-modern-trigger text-decoration-none" data-bs-toggle="collapse" aria-expanded="false" aria-controls="faqCollapseSeven">
                        <div class="faq-modern-trigger-inner">
                            <div class="faq-modern-icon-wrap"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="15" height="15" fill="#ffffff"><path d="M256 48a208 208 0 1 1 0 416A208 208 0 1 1 256 48zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H272V248c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v64H216zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/></svg></div>
                            <h5 class="faq-modern-question">Pourquoi suis-je redirigé vers un autre site pour finaliser mon achat ?</h5>
                            <div class="faq-modern-toggle"><span class="faq-toggle-minus">−</span><span class="faq-toggle-plus">+</span></div>
                        </div>
                    </a>
                    <div id="faqCollapseSeven" class="collapse" data-bs-parent="#faqAccordion">
                        <div class="faq-modern-body">Pour des transactions sécurisées, vous êtes redirigé vers le site de notre partenaire de paiement de confiance. Une fois votre achat finalisé, vous recevrez votre code d'activation IPTV par e-mail.</div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="faq-modern-card">
                    <a href="#faqCollapseEight" class="faq-modern-trigger text-decoration-none" data-bs-toggle="collapse" aria-expanded="false" aria-controls="faqCollapseEight">
                        <div class="faq-modern-trigger-inner">
                            <div class="faq-modern-icon-wrap"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="15" height="15" fill="#ffffff"><path d="M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"/></svg></div>
                            <h5 class="faq-modern-question">Puis-je payer mon abonnement avec PayPal ?</h5>
                            <div class="faq-modern-toggle"><span class="faq-toggle-minus">−</span><span class="faq-toggle-plus">+</span></div>
                        </div>
                    </a>
                    <div id="faqCollapseEight" class="collapse" data-bs-parent="#faqAccordion">
                        <div class="faq-modern-body">Oui, vous pouvez payer avec PayPal, Crypto ou d'autres méthodes. Envoyez-nous un message sur WhatsApp pour obtenir un lien direct. <a href="https://wa.me/33756756461" target="_blank" class="faq-whatsapp-link"><i class="fa-brands fa-whatsapp"></i> +33 756 756461</a></div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="faq-modern-card">
                    <a href="#faqCollapseThree" class="faq-modern-trigger text-decoration-none" data-bs-toggle="collapse" aria-expanded="false" aria-controls="faqCollapseThree">
                        <div class="faq-modern-trigger-inner">
                            <div class="faq-modern-icon-wrap"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="15" height="15" fill="#ffffff"><path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"/></svg></div>
                            <h5 class="faq-modern-question">Comment recevoir mon abonnement ?</h5>
                            <div class="faq-modern-toggle"><span class="faq-toggle-minus">−</span><span class="faq-toggle-plus">+</span></div>
                        </div>
                    </a>
                    <div id="faqCollapseThree" class="collapse" data-bs-parent="#faqAccordion">
                        <div class="faq-modern-body">Après le paiement, vous recevrez vos identifiants par e-mail sous 10 à 30 minutes. Vérifiez votre dossier spam. Si vous ne recevez rien, contactez-nous sur WhatsApp : <a href="https://wa.me/33756756461" target="_blank" class="faq-whatsapp-link"><i class="fa-brands fa-whatsapp"></i> +33 756 756461</a></div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="faq-modern-card">
                    <a href="#faqCollapseFour" class="faq-modern-trigger text-decoration-none" data-bs-toggle="collapse" aria-expanded="false" aria-controls="faqCollapseFour">
                        <div class="faq-modern-trigger-inner">
                            <div class="faq-modern-icon-wrap"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="15" height="15" fill="#ffffff"><path d="M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"/></svg></div>
                            <h5 class="faq-modern-question">Puis-je utiliser l'IPTV sur plusieurs appareils simultanément ?</h5>
                            <div class="faq-modern-toggle"><span class="faq-toggle-minus">−</span><span class="faq-toggle-plus">+</span></div>
                        </div>
                    </a>
                    <div id="faqCollapseFour" class="collapse" data-bs-parent="#faqAccordion">
                        <div class="faq-modern-body">Oui, si vous avez un abonnement Gold, vous pouvez regarder sur plusieurs appareils simultanément.</div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="faq-modern-card">
                    <a href="#faqCollapseFive" class="faq-modern-trigger text-decoration-none" data-bs-toggle="collapse" aria-expanded="false" aria-controls="faqCollapseFive">
                        <div class="faq-modern-trigger-inner">
                            <div class="faq-modern-icon-wrap"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="15" height="15" fill="#ffffff"><path d="M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.5 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.5-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z"/></svg></div>
                            <h5 class="faq-modern-question">Ai-je besoin d'une antenne satellite pour utiliser l'IPTV ?</h5>
                            <div class="faq-modern-toggle"><span class="faq-toggle-minus">−</span><span class="faq-toggle-plus">+</span></div>
                        </div>
                    </a>
                    <div id="faqCollapseFive" class="collapse" data-bs-parent="#faqAccordion">
                        <div class="faq-modern-body">Non, vous vous connectez aux serveurs IPTV TVPLUX via Internet. Vous n'avez pas besoin d'une parabole ou d'un équipement satellite.</div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="faq-modern-card">
                    <a href="#faqCollapseSix" class="faq-modern-trigger text-decoration-none" data-bs-toggle="collapse" aria-expanded="false" aria-controls="faqCollapseSix">
                        <div class="faq-modern-trigger-inner">
                            <div class="faq-modern-icon-wrap"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="15" height="15" fill="#ffffff"><path d="M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.5 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.5-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z"/></svg></div>
                            <h5 class="faq-modern-question">Ce service (IPTV) fonctionne-t-il dans mon pays ?</h5>
                            <div class="faq-modern-toggle"><span class="faq-toggle-minus">−</span><span class="faq-toggle-plus">+</span></div>
                        </div>
                    </a>
                    <div id="faqCollapseSix" class="collapse" data-bs-parent="#faqAccordion">
                        <div class="faq-modern-body">L'IPTV fonctionne partout dans le monde. Tant que vous disposez d'une connexion Internet stable, vous pouvez regarder des milliers de chaînes TV.</div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<!--FAQ End-->


        <!-- Footer Area -->
         <!-- Footer Area End -->


    
    <!-- main content wrapper ends -->


    <!--build:js-->
    
    
    
    
    
    
    
    
    
    
        
    

    <!--=============== MAIN JS ===============-->
    
    
    <a href="https://wa.me/33756756461" class="float" target="_blank">
    <i class="fa-brands fa-whatsapp my-float"></i>
    </a>

    <!--endbuild-->

 
</div>` }} />
  );
}
